import QueryDropdown, { QueryDropdownProps, QueryDropdownRef } from '@/components/QueryDropdown';
import { forwardRef } from 'react';

import { DEFAULT_TIME_FRAME_RANGES } from '../TimeFrameModal';
import { DropdownItem } from '@/components/Dropdown';
import { refetchSearchTimeFrame } from '@/features/DriveTimeTool/api/services/searchTimeFrame';

const getItems = async (): Promise<DropdownItem[]> => {
  const output = [
    {
      label: `Default ${DEFAULT_TIME_FRAME_RANGES.length} Period(s)`,
      value: 'default',
    },
  ];
  const res = await refetchSearchTimeFrame(null, { pageSize: null });
  (res?.rows || []).forEach((timeFrame) => {
    output.push({
      label: timeFrame.name,
      value: `${timeFrame.id}||${timeFrame.name}`,
    });
  });
  return output;
};
const TimeFrameDropdown = forwardRef<QueryDropdownRef, Partial<QueryDropdownProps>>((props, ref) => {
  return (
    <QueryDropdown
      name="TimeFrame"
      {...props}
      value={props.value}
      onChange={props.onChange}
      query={getItems}
      options={{
        ...(props.options || {}),
        ttl: 1000,
        locale: {
          'No Options': 'No Presets',
          'Select...': props?.placeholder || 'Load Preset Configuration',
          ...(props.options?.locale || {}),
        },
      }}
      ref={ref}
    />
  );
});

export default TimeFrameDropdown;
